export function getMonthlyPackagePricing(
  monthlyPackageSelected: boolean,
  quarterlyPackageSelected: boolean,
  halfyearlyPackageSelected: boolean,
  yearlyPackageSelected: boolean,
): string {
  // DANE UNIWERSALNE
  var packagePriceMonthly = '0.0';
  const newPricingEnabled: boolean = isNewPricingEnabled();

  // ZWRACANIE DANYCH
  if (monthlyPackageSelected) {
    if (newPricingEnabled) {
      packagePriceMonthly = monthly_price.toFixed(2)
    }

    else {
      packagePriceMonthly = __old_monthly_price.toFixed(2)
    }
  }

  else if (quarterlyPackageSelected) {
    if (newPricingEnabled) {
      packagePriceMonthly = (quarterly_price / 3).toFixed(2)
    }

    else {
      packagePriceMonthly = (__old_quarterly_price / 3).toFixed(2)
    }
  }

  else if (halfyearlyPackageSelected) {
    if (newPricingEnabled) {
      packagePriceMonthly = (halfyearly_price / 6).toFixed(2)
    }

    else {
      packagePriceMonthly = (__old_halfyearly_price / 6).toFixed(2)
    }
  }

  else if (yearlyPackageSelected) {
    if (newPricingEnabled) {
      packagePriceMonthly = (yearly_price / 12).toFixed(2)
    }

    else {
      packagePriceMonthly = (__old_yearly_price / 12).toFixed(2)
    }
  }

  else {}

  // ZWRACANIE DANYCH
  return packagePriceMonthly;
}


// INFORMACJA CZY OBOWIĄZUJE NOWY CENNIK

export function isNewPricingEnabled(): boolean {
  // SPRAWDZANIE CZY TO JUŻ PORA NA NOWY CENNIK
  const oldPricingDate: Date = new Date(2024,0,1, 0, 0, 0);
  const today: Date = new Date();
  const isTodayAfterOldPricingDate: boolean = today >= oldPricingDate;

  return isTodayAfterOldPricingDate;
}

//
// CENY NETTO
//

const __old_monthly_price = 88.00;
const monthly_price = 99.00;

const __old_quarterly_price = 249.00;
const quarterly_price = 279.00;

const __old_halfyearly_price = 479.00;
const halfyearly_price = 539.00;

const __old_yearly_price = 888.00;
const yearly_price = 999.00;

//
// CENY PAKIETÓW
//

export function getMonthlyPackagePrice(): number {
  return isNewPricingEnabled() ? monthly_price : __old_monthly_price
}

export function getQuarterlyPackagePrice(): number {
  return isNewPricingEnabled() ? quarterly_price : __old_quarterly_price
}

export function getHalfyearlyPackagePrice(): number {
  return isNewPricingEnabled() ? halfyearly_price : __old_halfyearly_price
}

export function getYearlyPackagePrice(): number {
  return isNewPricingEnabled() ? yearly_price : __old_yearly_price
}

export function getElectronicSettlementPackagePrice(eSettlementQuantity: number): number {
  return 5 * eSettlementQuantity
}


// WEBPACK FOOTER //
// ./src/constants/pricing-data.ts